import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupCurrency } from "../../../Shared/NewForms/NFlookupCurrency";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

const CashRegisterDetailMain = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCompany title={t("Company")} fieldName={"companyId"} />
        </Col>
        <Col sm={6}>
          <NFDateInput fieldName={"createdDate"} title={t("CreatedDate")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCurrency fieldName={"currencyId"} title={t("Currency")} />
        </Col>
        <Col sm={6}>
          <NFLookupDivision fieldName={"divisionId"} title={t("Division")} companyId={watch('companyId')} />
        </Col>
      </Row>
    </>
  );
};

export default CashRegisterDetailMain;
